import { type SearchRequest } from '@searchkit/api';
import { merge } from 'merge-anything';

import { type SearchRuntimeSortingOption } from '~/search-domain/types';

export function createQueryFactory(config: { activeSort: SearchRuntimeSortingOption; searchRequest: SearchRequest }) {
  const { activeSort, searchRequest } = config;

  const order = {
    [activeSort.field]: activeSort.order,
  };

  const sortAggregate = {
    [activeSort.field]: {
      max: {
        field: activeSort.field,
      },
    },
  };

  return merge(searchRequest, {
    body: {
      size: 0,
      aggs: {
        subevents: {
          terms: {
            field: 'subeventId',
            size: 10000,
            order,
          },
          aggs: {
            ...sortAggregate,
            markets: {
              terms: {
                field: 'marketId',
                size: 10000,
              },
              aggs: {
                bets: {
                  terms: {
                    field: 'betId',
                    size: 10000,
                  },
                  aggs: {
                    best_odds: {
                      top_hits: {
                        sort: {
                          oddsDecimal: 'desc' as const,
                        },
                        size: 1,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  }) as SearchRequest;
}
